import { Calculator } from '@webapp/landing/src/components/ru/respondent-panel/calculator/calculator';

import css from './respondent-panel.css';

export const RespondentPanel: FC = () => {
    return (
        <div className={css.respondentPanel}>
            <h2>Панель респондентов Тестограф — респонденты для опросов по целевым критериям</h2>
            <p>
                В Тестограф интегрирована крупнейшая потребительская онлайн панель респондентов в России. Панель
                позволяет быстро получить доступ к более 780 000 человек по всей стране и предоставляет гибкую
                фильтрацию по 20+ параметрам, чтобы вы могли опросить именно вашу целевую аудиторию. Инструмент подходит
                для маркетинговых, UX-исследований и других проектов, где нужны надежные данные от реальных
                потребителей.
            </p>
            <p className={css.bold}>Калькулятор расчёта стоимости кампании</p>
            <p>Укажите необходимые критерии и получите расчет стоимости запуска опроса по панели респондентов.</p>
            {<Calculator />}
            <p className={css.bold}>Как запустить кампанию по панели</p>
            <p>
                Запуск опроса по панели респондентов в testograf осуществляется в несколько шагов, процесс полностью
                автоматизирован и удобен:
            </p>
            <p>
                - <span className={css.bold}>Создание кампании.</span> В личном кабинете Тестограф создайте новую
                кампанию опроса, задайте название и краткое описание цели исследования.
            </p>
            <p>
                - <span className={css.bold}>Настройка целевой аудитории.</span> Выберите критерии отбора респондентов:
                укажите социально-демографические параметры, географию, интересы и любые другие фильтры, необходимые для
                вашей задачи. Система покажет оценочное количество доступных людей из панели по заданным критериям.
            </p>
            <p>
                - <span className={css.bold}>Расчет стоимости.</span> Воспользуйтесь встроенным калькулятором стоимости
                опроса – задайте желаемое число анкет (ответов) и увидите, сколько будет стоить сбор данных с учетом
                выбранной аудитории и длины анкеты. Цена формируется прозрачно, исходя из числа респондентов и сложности
                выборки.
            </p>
            <p>
                - <span className={css.bold}>Оплата и запуск.</span> Пополните баланс аккаунта (виртуальный кошелёк) на
                рассчитанную сумму и подтвердите запуск опроса. Можно оплатить счёт удобным способом (например,
                банковской картой или безналично). После оплаты кампания автоматически стартует – приглашения
                отправляются подходящим панелистам.
            </p>
            <p>
                - <span className={css.bold}>Сбор ответов.</span> Остается дождаться, пока требуемое количество
                респондентов пройдет опрос. Набор ответов происходит автоматически: как только нужное число анкет будет
                заполнено, опрос останавливается. Вы получите уведомление и сможете сразу выгрузить данные для анализа
                (в формате Excel, CSV и пр.).
            </p>
            <p>
                Весь процесс – от настройки до получения результатов – может занимать от нескольких часов до нескольких
                дней в зависимости от масштаба исследования. В среднем, ответы от нескольких сотен человек собираются в
                течение 1-2 дней. Вы можете мониторить ход выполнения в реальном времени через личный кабинет.
            </p>
            <p className={css.bold}>Стоимость и оплата за ответы</p>
            <p>
                Стоимость опроса по панели зависит от количества респондентов, требуемых критериев отбора и длины
                анкеты. Наш сервис применяет прозрачную модель «оплата за ответы»: вы платите только за фактически
                полученные заполненные анкеты. При настройке кампании вы сразу видите расчет стоимости – никаких скрытых
                платежей. Например, если вам нужно 100 ответов от определенной аудитории, система покажет цену за сбор
                этих 100 анкет. В эту сумму уже включено вознаграждение респондентам за участие, а также все расходы на
                поддержание панели. Оплата производится через удобный онлайн-кошелёк на платформе. Вы пополняете баланс
                на сумму, достаточную для сбора нужных ответов (с запасом или точно по расчету), после чего средства
                списываются по мере поступления заполненных анкет. Если по итогам кампании было собрано меньше ответов
                (например, аудитория оказалась меньше ожидаемой), неизрасходованные средства остаются на вашем балансе и
                могут быть использованы для следующих опросов.
            </p>
            <p>
                Таким образом, вы полностью контролируете бюджет исследования и оплачиваете только результаты. Стоимость
                одного ответа варьируется в зависимости от сложности целевой выборки и длины опроса, но всегда
                рассчитывается и согласовывается заранее с помощью калькулятора.
            </p>
            <p className={css.bold}>Требования к содержанию опроса</p>
            <p>
                Чтобы опрос успешно прошел модерацию и был разослан панелистам, необходимо соблюдать требования к
                анкете:
            </p>
            <p>
                - <span className={css.bold}>Запрещённые темы и содержание:</span> В вопросах не должно быть
                ненормативной лексики, оскорбительных высказываний, пропаганды экстремизма, насилия, порнографии или
                иных запрещённых законодательством тем. Также не допускаются опросы, которые используются для рекламы
                конкретных товаров/услуг либо сбора персональных данных респондентов (например, контактов).
            </p>
            <p>
                - <span className={css.bold}>Допустимая длина анкеты:</span> Максимальное рекомендуемое количество
                вопросов – не более 70. Слишком длинные опросы утомляют участников и снижают качество ответов.
                Оптимально делать опрос компактным (10–30 вопросов) в зависимости от сложности темы, чтобы респонденты
                не теряли интерес и доходили до конца анкеты.
            </p>
            <p>
                - <span className={css.bold}>Корректность формулировок:</span> Все вопросы должны быть сформулированы
                ясно и нейтрально. Избегайте двусмысленностей и наводящих (leading) вопросов, которые могут склонять
                респондента к определенному ответу. Проверяйте грамматику и корректность – ошибки или непонятные
                формулировки могут запутать участника. Если используются изображения или видео в вопросах, убедитесь,
                что они корректно отображаются и не содержат шокирующих материалов.
            </p>
            <p>Перед запуском каждую анкету проверяют модераторы платформы на соответствие этим требованиям.</p>
            <p className={css.bold}>Что такое панель респондентов?</p>
            <p>
                <span className={css.bold}>Панель респондентов</span> (онлайн-панель) – это сообщество людей, заранее
                согласившихся регулярно участвовать в опросах за небольшое вознаграждение. Участники панели добровольно
                регистрируются на платформе и предоставляют информацию о себе: пол, возраст, регион проживания,
                интересы, уровень дохода и др. Благодаря этому формируется большая онлайн-панель с профилями
                респондентов, готовых отвечать на вопросы по разным темам.
            </p>
            <p>
                В Тестограф интегрирована такая панель и сервис предоставляет исследователям респондентов для опросов по
                заданным критериям. Каждый участник панели отвечает на анкеты в удобное время через интернет. За участие
                в опросах респонденты получают вознаграждение (баллы или деньги), поэтому модель часто называют «оплата
                за ответы» – вы платите за каждый собранный ответ. Это выгодно всем: целевые респонденты мотивированы
                пройти анкету, а заказчик быстро получает нужные данные.
            </p>
            <p className={css.bold}>Преимущества онлайн-панели для опросов</p>
            <p>
                Использование панели респондентов, интегрированной в Тестограф, дает ряд преимуществ перед традиционными
                методами сбора данных:
            </p>
            <p>
                - <span className={css.bold}>Быстрый сбор данных:</span> Онлайн-опрос запускается мгновенно, и первые
                ответы можно получить уже в течение первых часов. Не нужно ждать недели, как при полевых опросах –
                доступ к респондентам осуществляется сразу через интернет.
            </p>
            <p>
                - <span className={css.bold}>Широкий охват аудитории:</span> В панели зарегистрированы жители всех
                регионов РФ, городов и населённых пунктов. Это позволяет проводить общероссийские опросы или
                таргетировать определенный регион/город. Большой размер панели обеспечивает репрезентативность выборки
                по многим параметрам.
            </p>
            <p>
                - <span className={css.bold}>Точная сегментация (таргетинг):</span> Доступна фильтрация участников по
                более чем 20 критериям – возраст, пол, образование, доход, семейное положение, профессия, регион,
                интересы и другие. Вы легко найдете респондентов для опроса именно из вашей целевой группы (например,
                молодые мамы, автовладельцы, пользователи смартфонов определенной марки и т.д.).
            </p>
            <p>
                - <span className={css.bold}>Экономия времени и средств:</span> Проведение опроса через онлайн-панель
                зачастую дешевле и быстрее, чем организация личных интервью или телефонных обзвонов. Не требуется
                нанимать интервьюеров или выезжать в точки сбора – все происходит онлайн. Вы платите только за
                полученные ответы, что оптимизирует бюджет исследования.
            </p>
            <p>
                - <span className={css.bold}>Качество и надежность данных:</span> Наши панелисты верифицированы и
                регулярно участвуют в опросах, поэтому вы получаете ответы от реальных людей, а не случайных
                онлайн-пользователей. Встроенные системы контроля качества отсеивают недобросовестные анкеты (слишком
                быстрые прохождения, противоречивые ответы), обеспечивая валидные результаты.
            </p>
            <p className={css.bold}>Фильтрация и целевая аудитория</p>
            <p>
                Одно из ключевых преимуществ панели, интегрированной в Тестограф, – гибкое таргетирование нужных
                респондентов. Система позволяет настроить критерии отбора по 20+ параметрам, чтобы опрос прошли именно
                представители вашей целевой аудитории. Доступны фильтры по следующим категориям:
            </p>
            <p>
                - <span className={css.bold}>Социально-демографические:</span> возраст, пол, регион и город проживания,
                тип населенного пункта, уровень образования, семейное положение, наличие детей.
            </p>
            <p>
                - <span className={css.bold}>Экономические:</span> уровень дохода, род деятельности, должность, сфера
                работы.
            </p>
            <p>
                - <span className={css.bold}>Потребительские:</span> наличие автомобиля, жилья, бытовой техники,
                домашних животных; предпочтения в категориях товаров (например, пользуются банковскими услугами, любят
                спортивные занятия, играют в видеоигры).
            </p>
            <p>
                - <span className={css.bold}>Поведенческие и интересы:</span> хобби и увлечения, путешествия,
                использование интернета и гаджетов, интерес к определенным тематикам (мода, здоровье, финансы и др.).
            </p>
            <p>
                Благодаря таким категориям вы можете получить ответы именно от тех людей, которые соответствуют портрету
                вашей целевой группы. Например, если нужно провести опрос целевой аудитории нового продукта – можно
                задать фильтры по возрасту, уровню дохода и интересу к данной категории товаров. Панель найдет
                подходящих участников и вышлет им приглашение пройти анкету.
            </p>
            <p>
                Большой размер панели (780 тысяч участников) означает, что даже при узких критериях отбора найдется
                достаточное число респондентов для получения статистически значимых результатов. Однако совсем
                экзотические аудитории (например, люди с очень редким заболеванием или узкие B2B-специалисты) могут быть
                недоступны на массовой панели – в таких случаях требуется индивидуальный рекрутинг. В большинстве же
                потребительских сегментов онлайн-панель закрывает потребности исследования.
            </p>
            <p>
                Тестограф предлагает вам профессиональный и удобный инструмент для онлайн-исследований. Наша панель
                респондентов сочетает огромный охват, гибкость настройки и высокое качество данных. Придерживаясь
                рекомендаций по подготовке опроса, вы сможете быстро получить ценные инсайты от целевой аудитории и
                принять верные решения для развития вашего продукта или бизнеса. Используйте автоматизацию Тестографа и
                возможности крупнейшей панели респондентов в России для успеха ваших исследований.
            </p>
        </div>
    );
};
